<template>
  <figure class="image">
    <legend class="has-background-white" style="padding: 0.25rem">{{$t('Page')}} {{ number }}</legend>
    <b-image ref="image" :src="source" :alt="label" @load="load" ratio="1by1"/>
  </figure>
</template>
<style scoped>
.image{
  min-height: 10rem;
  min-width: 6rem;
}
</style>

<script>
 export default {
   props: {
     number: {
       type: Number,
       required: true
     },
     source: {
       type: String,
       required: true
     },
     label: {
       type: String,
       default: ''
     }
   },
   data() {
     return {
       imageSource: null,
       width: 120,
       height: 100
     }
   },
   computed: {
     styles() {
       return {
	 display: 'inline-block',
	 width: `${this.width}px`,
	 height: `${this.height}px`,
	 backgroundColor: 'rgb(0, 0, 0, 0.075)'
       } 
     }
   },
   methods: {
     load(event) {
       this.width = event.target.naturalWidth
       this.height = event.target.naturalHeight
     }
   }
 }
</script>
